//import { useState } from 'react';
import React from "react";
import "./CpntFacette.scss";
import Skeleton from "@mui/material/Skeleton";

interface IProps {
  //onChange: (filtre: IFacetteFiltre,checked: boolean ) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  Libelle: string;
  Quantite: number;
  FacetteSelected: boolean;
  cssClassOuterBox?: string;
  cssClassInnerBox?: string;
  SkeletonVisible: boolean;
  InfoBulle? : string;
  Disabled? : boolean;
}

const CpntFacette: React.FC<IProps> = ({
  onChange,
  Libelle,
  Quantite,
  FacetteSelected,
  cssClassOuterBox,
  cssClassInnerBox,
  SkeletonVisible,
  InfoBulle,
  Disabled = false
}) => {

  
  //const _Libelle = Facette.Libelle.toLowerCase();
    return (
      <div className={`${cssClassOuterBox} `}>
      {(SkeletonVisible)? 
         <Skeleton variant="rectangular" className={`btn mx-1 facette-style ${cssClassInnerBox && cssClassInnerBox}`} />
         :
        <label 
          // key={"chk_" + _Libelle}
          className={`form-check btn facette-style ${cssClassInnerBox && cssClassInnerBox} ${FacetteSelected && "facette-selected" }`} 
          title={InfoBulle}
          >
          <input
            type="checkbox"
            className="btn-check form-check-input"
            // id={`btn-check-${_Libelle}`}
            onChange={onChange}
            checked={FacetteSelected}
            disabled = {Disabled}
          />
          <span style={{ flex: 1, textAlign: "center" }}>
            {Libelle}
          </span>
          <span className={`facette-style-number`}
          >
            {Quantite}
          </span>
          </label>
       
      }
       </div>
  );
   };

  export default CpntFacette;
